import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import ContactPageContent from './ContactPageContent';

export const ContactPage = props => {
  return (
    <div>
      <ContactPageContent restaurant={props.restaurant} />
    </div>
  );
};

ContactPage.propTypes = {
  restaurant: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language
  };
};

export default connect(mapStateToProps)(ContextProvider(ContactPage));



// WEBPACK FOOTER //
// ./containers/ContactPage/ContactPage.js